import { useMutation, useQueryClient } from "react-query";
import { t } from "@/i18n-js/instance";
import { EMAIL_HUB_STATUS_QUERY_KEY } from "@/react/hooks/useGetEmailHubStatus";
import type {
  CreateBroadcastParams,
  IdResponseData,
} from "@circle-react/api/broadcastsApi";
import { broadcastsApi } from "@circle-react/api/broadcastsApi";
import type { ApiError } from "@circle-react/config/CustomErrors";
import { useToast } from "@circle-react-shared/uikit/ToastV2";

const i18nBase = "settings.emails.broadcasts.new_broadcast_modal";

export const useBroadcastCreate = () => {
  const toastr = useToast();
  const queryClient = useQueryClient();
  return useMutation<IdResponseData, ApiError, CreateBroadcastParams>({
    mutationFn: data => broadcastsApi.create(data),
    onSuccess: () => {
      void queryClient.invalidateQueries(EMAIL_HUB_STATUS_QUERY_KEY);
    },
    onError: () => toastr.error(t([i18nBase, "error_saving"])),
  });
};
